
import { Component, Vue, Prop } from 'vue-property-decorator'
import { NavBar, MenuBar } from '@/components'
import draggable from 'vuedraggable'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    MenuBar,
    NavBar,
    draggable
  }
})
export default class TaskQuestionCard extends Vue {
  @Prop({ required: true })readonly obj: any

  data () {
    return {
      isLoading: false,
      taskId: null,
      remainTime: '',
      disabled: true,
      taskData: null,
      score: null,
      scoreReason: null,
      description: '',
      words: [],
      content: '',
      wordsSequence: [],
      isCorrectArr: [],
      isDragging: false
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.prepareTaskData()
    // this.mockTaskData()
  }

  fillRemainTime (due) {
    if (due) {
      var now = new Date()
      var days = (due.valueOf() - now.valueOf()) / (1000 * 3600 * 24)
      if (days <= 0) {
        this.remainTime = 'Expired'
      } else {
        var hours = (days - Math.floor(days)) * 24
        var mins = 0
        if ((hours - Math.floor(hours)) > 0) {
          mins = (hours - Math.floor(hours)) * 60
        }
        var daysString = days < 10 ? days < 1 ? '' : `0${Math.floor(days)} Days and ` : `${Math.floor(days)} Days and `
        var hoursString = hours < 10 ? `0${Math.floor(hours)}` : Math.floor(hours)
        var minsString = mins < 10 ? `0${Math.floor(mins)}` : Math.floor(mins)

        this.remainTime = `${daysString}${hoursString}:${minsString} h `
      }
    } else {
      this.remainTime = ''
    }
  }

  displayModalFinish () {
    this.$buefy.dialog.confirm({
      title: 'Are you sure?',
      message: 'By confirming, you won`t be able to change it back.',
      onConfirm: () => {
        this.finish()
      },
      canCancel: true
    })
  }

  async save () {
    await this.updateOnServer(false)
  }

  async finish () {
    await this.updateOnServer(true)
  }

  onMove ({ relatedContext, draggedContext }) {
    const relatedElement = relatedContext.element
    const draggedElement = draggedContext.element
    return (
      (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    )
  }

  async prepareTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      if (resp.data) {
        this.taskData = JSON.parse(resp.data)
        this.description = resp.description
        if (this.taskData.content) {
          console.log('it has content')
          this.wordsSequence = this.taskData.content
        } else {
          console.log('it does not have content')
          var correctAnswer = this.taskData.correctAnswer.split(' ')
          while (correctAnswer.length > 0) {
            var idx = Math.floor(Math.random() * correctAnswer.length)
            this.wordsSequence.push(correctAnswer[idx])
            correctAnswer.splice(idx, 1)
          }
        }
      }
      this.score = resp.score
      this.scoreReason = resp.scoreReason
      this.disabled = resp.completed || new Date(resp.due) <= new Date()
      if (this.score) {
        correctAnswer = this.taskData.correctAnswer.split(' ')
        for (var i = 0; i < this.wordsSequence.length; i++) {
          this.isCorrectArr.push(this.wordsSequence[i] === correctAnswer[i])
        }
      }
      this.fillRemainTime(new Date(resp.due))
      if (!this.taskId) {
        this.taskId = resp.id
      }
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      console.error(e)
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async mockTaskData () {
    this.isLoading = true
    try {
      var resp = this.obj
      this.description = 'reorder following words'
      this.disabled = false
      this.wordsSequence = ['is', 'car', 'beautiful', 'This', 'By', 'confirming', 'you', 'won`t', 'be', 'able', 'to', 'change', 'it', 'back.']
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      console.error(e)
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }

  async updateOnServer (completed) {
    this.isLoading = true
    var data = {
      content: this.wordsSequence
    }
    try {
      const resp = await FetchWrapper.post(
        `${process.env.VUE_APP_SERVERURL}/updateReorderWordsTaskData`,
        { data: data, id: Number(this.taskId), completed }
      )
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Task saved Successfully',
        onConfirm: () => {
          if (completed) {
            window.location.href = `/home/task/${this.taskId}`
          }
        },
        canCancel: false
      })
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      console.error(e)
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not save task data. ${e}`,
        canCancel: false
      })
    }
  }
}
